<template>
    <div ref="intro_pane" id="intro_pane_1" class="intro-wrapper position-relative bg-texture mb-5 mb-lg-0"> 
        <div id="newspaper" class="vh-100 position-absolute"></div>
        <div class="container ml-4 ml-sm-5 pl-5">
            <div class="row align-items-center vh-90">
                <div class="col-9 col-sm-6">
                    <h2 class="guide-text copper tilt mt-4 mt-lg-0">{{ $t(iKey('case_study_section', 'case_study_intro', 'label')) }}</h2>
                    <h3 class="my-4">{{ $t(iKey('case_study_section', 'case_study_intro', 'headline')) }}</h3>
                    <p class="explainer2">{{ $t(iKey('case_study_section', 'case_study_intro', 'description')) }}</p>
                </div>

                <div class="col-7 col-lg-4 portraits-wrapper">
                    <div :style="{'backgroundImage': textureImage(items[0]) }" class="img-wrap texture">
                        <img 
                            v-lazy="items[0].main_image.url_resized_portrait" class="img1 img-fluid" 
                            :alt="$t(iKey('related_case_studies', items[0], 'main_image_desc'))">
                    </div>

                    <div :style="{'backgroundImage': textureImage(items[1]) }" class="img-wrap texture">
                        <img 
                            v-lazy="items[1].main_image.url_resized_portrait" class="img2 img-fluid" 
                            :alt="$t(iKey('related_case_studies', items[1], 'main_image_desc'))">
                    </div>
                </div>
            </div>
        </div>
        
        <CtaCircle 
            @clicked="$parent.scrollToPane('#cs_0_pane_1')" 
            id="more_circle" 
            :trigger="'#case_studies_wrapper'" 
            :offset="'-200'"
            :label="$t(iKey('case_study_section', 'case_study_intro', 'cta'))"
            :color="'ad841f'"
            :direction="'right'">
        </CtaCircle>
    </div>
</template>

<script>
import CtaCircle from '@/components/ui/CtaCircle'

export default {
    name: 'CaseStudies',
    components: {
        CtaCircle
    },
    props: [
        'items'
    ],
    methods: {
        textureImage(caseStudy){
            let bgImg = ''
            if(caseStudy.texture_image){
                bgImg = caseStudy.texture_image.url_resized_large
            }
            return 'url(' + bgImg + ')'
        }
    },
    mounted() {
           var dur = this.windowHeight
            const scene = this.$scrollmagic.scene({
                triggerElement: '#case_studies_wrapper',
                offset: -200,
                duration: dur
            })
            this.$scrollmagic.addScene(
            scene
                .on("enter", () => {
                    if(this.$refs.intro_pane !== undefined){
                        this.$refs.intro_pane.classList.add('in');
                    }
                })
            )
    }
}
</script>

<style scoped>
#intro_pane_1 {
    position: relative;
    width: auto;
    transition: width 0.9s ease;
}
#intro_pane_1.in {
    width: auto;
}
@media (min-width: 992px) { 
    #intro_pane_1 {
        width: 180vw;
        min-width: 180vw; /* ie 11 bug */
    }
    #intro_pane_1.in {
        width: 110vw;
        min-width: 110vw; /* ie 11 bug */
    }
}
#more_circle {
    right: 100px;
    top: 20%;
    position: absolute;
}
.img-wrap .img1 {
    transform: rotate(-5deg);
    margin-top: 20px;
    margin-left: 20px;
}
.img-wrap .img2 {
    transform: rotate(5deg);
    margin-left: 150px;
}
.img-wrap .img-fluid{
    width: 70%;
}
.img-wrap.texture {
    
    background-size: contain;
    background-repeat: no-repeat;
    
}
.img-wrap.texture {
    /* background-position-x: -50px; */
    /* background-size: 100%; */
}
.tilt {
    transform: rotate(-2deg);

}
@media (min-width: 992px) { 
    .tilt {
        
        margin-top: -50px;
        margin-bottom: 50px;
    }
}
#newspaper {
    background-image: url(../../assets/images/newspaper.jpg);
    background-size: cover;
    background-repeat: no-repeat;
    width: 40px;
}
.bg-texture {
    background-image: url(../../assets/images/photocopy-bg.jpg);
    background-repeat: no-repeat;
    background-size: cover;
}

</style>